import script from "./CompanyApplyPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyApplyPage.vue?vue&type=script&setup=true&lang=ts"

import "./CompanyApplyPage.vue?vue&type=style&index=0&id=1a989bc0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a989bc0"]])

export default __exports__